(function () {
  "use strict";

  class ConvxDesktopNav extends HTMLElement {
    constructor() {
      super();
      this.header = null;
      this.announcementBar = null;
      this.lastScrollPos = 0;
      this.stickyTransitioning = false;
    }

    connectedCallback() {
      this.header = document.querySelector("#SiteHeader");
      this.announcementBar = document.querySelector(
        ".announcement-bar.new-announcement-bar"
      );

      if (window.innerWidth > 768) {
        this.initMenu();
      }
      this.initStickyHeader();

      window.addEventListener("scroll", this.handleScroll.bind(this));
      this.lastWidth = window.innerWidth;
      window.addEventListener("resize", () => {
        // phones fire resize when the address bar shows/hides on scroll —
        // only a width change actually reflows the page
        if (window.innerWidth !== this.lastWidth) {
          this.lastWidth = window.innerWidth;
          window.convxHeaderReflowAt = Date.now();
        }
        // page opened in a narrow window and then widened — the desktop
        // menu was never wired up, so do it now
        if (window.innerWidth > 768) this.initMenu();
        this.updateHeaderOffsets();
        this.updateMenuWrapLayout();
      });

      window.addEventListener("load", () => {
        this.updateHeaderOffsets();
        this.updateMenuWrapLayout();
      });

      this.updateHeaderOffsets();
      this.updateMenuWrapLayout();
    }

    // when the nav links wrap to more than one row, "Clearance Sale" should
    // fold into the same left-aligned flow instead of staying pinned right
    updateMenuWrapLayout() {
      const menuInner = this.querySelector(".convx__desktop-menu-inner");
      if (!menuInner) return;

      const items = Array.from(menuInner.children);
      if (!items.length) return;

      const firstTop = items[0].offsetTop;
      const wrapped = items.some((item) => item.offsetTop !== firstTop);
      menuInner.classList.toggle("convx__desktop-menu-inner--wrapped", wrapped);
    }

    initMenu() {
      if (this.menuInited) return;
      this.menuInited = true;
      const dropDown = this.querySelectorAll(
        ".convx__desktop-menu li > .convx__menu-link.desktop"
      );
      dropDown.forEach((item) => {
        item.addEventListener("click", (e) => this.disableClick(e));
        item.addEventListener("mouseenter", (e) => this.showDropdown(e));
      });

      const headerWrapper = document.querySelector(".header-wrapper--sticky");

      if (headerWrapper) {
        headerWrapper.addEventListener("mouseleave", (e) => {
          if (e.relatedTarget && headerWrapper.contains(e.relatedTarget)) return;

          if (this.timeout) clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            this.resetHeaderState();
            this.timeout = null;
          }, 400);
        });
      }
      // reset when mouse leaves menu area
      const menuWrapper = this.querySelector(".convx__desktop-menu");
      if (menuWrapper) {
        menuWrapper.addEventListener("mouseleave", (e) => {
          // the un-stretched <ul> is only as tall as the link text, so the
          // pointer exits this box well before reaching the dropdown below
          // it — only reset once the mouse actually leaves the header
          const safeZone = this.header || this;
          if (e.relatedTarget && safeZone.contains(e.relatedTarget)) return;

          this.activeDropdownRef = null;
        });
      }

      const first_level = this.querySelectorAll(
        ".convx__first-level-nav .convx__nav-collection-card"
      );
      first_level.forEach((link) => {
        link.addEventListener("click", (e) => this.showSecondLevel(e));
      });

      const sidebar = this.querySelectorAll(
        ".convx__nav-sidebar .convx__nav-sidebar-link"
      );
      sidebar.forEach((link) => {
        link.addEventListener("click", (e) => this.showThirdLevel(e));
      });

      const self = this;
      this.timeout = null;
      this.querySelectorAll(".convx__collection-nav-dropdown").forEach((dropdown) => {
        dropdown.addEventListener("mouseleave", () => {
          // clear previous timeout if exists
          if (this.timeout) clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            dropdown.classList.remove("active");
            // forget it was open, otherwise hovering the same link again
            // hits the "already active" guard in showDropdown and nothing opens
            this.activeDropdownRef = null;
            const anyActive = this.querySelector(
              ".convx__collection-nav-dropdown.active"
            );
            if (!anyActive) {
              const shoppingBar = document.querySelector(".shopping-bar");
              if (shoppingBar) shoppingBar.classList.remove("hide-shopping-bar");
              const siteHeader = document.querySelector(
                ".header-wrapper--sticky .site-header"
              );
              const menuLink = document.querySelectorAll("a.convx__menu-link");
              const flag = document.querySelector(".regions-flag-small-btn");
              const logo = document.querySelectorAll(".site-header__logo img");
              const icons = document.querySelectorAll(
                ".header-item--icons .site-nav__link"
              );
              if (siteHeader) siteHeader.classList.remove("active");
              if (menuLink)
                menuLink.forEach((item) => {
                  item.classList.remove("active");
                });
              if (flag) flag.classList.remove("active");
              if (logo)
                logo.forEach((item) => {
                  item.classList.remove("active");
                });
              if (icons)
                icons.forEach((item) => {
                  item.classList.remove("active");
                });
            };

            this.timeout = null;
          }, 400); // 400ms delay
        });

        dropdown.addEventListener("mouseenter", () => {
          // Cancel if mouse comes back in
          if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
          }
        });
      });

      const menuLinks = this.querySelectorAll(
        ".convx__desktop-menu > li, .convx__desktop-menu-inner > li"
      );

      menuLinks.forEach((li) => {
        li.addEventListener("mouseenter", () => {
          // just passing through this <li> (e.g. crossing a second row of
          // links on the way down to another item's dropdown) shouldn't
          // close anything — only the link's own hover (showDropdown)
          // decides when to switch the active dropdown
          if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
          }
        });

        li.addEventListener("mouseleave", (e) => {
          // moving into this item's own dropdown, or into another menu
          // item, is handled by their own listeners — only schedule a
          // close when the mouse actually leaves the whole nav
          if (e.relatedTarget && this.contains(e.relatedTarget)) return;

          if (this.timeout) clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            this.resetHeaderState();
            this.timeout = null;
          }, 400);
        });
      });
    }

    resetHeaderState() {
      const dropdowns = this.querySelectorAll(".convx__collection-nav-dropdown");
      dropdowns.forEach(d => d.classList.remove("active"));

      const siteHeader = document.querySelector(".header-wrapper--sticky .site-header");
      const menuLinks = document.querySelectorAll("a.convx__menu-link");
      const flag = document.querySelector(".regions-flag-small-btn");
      const logos = document.querySelectorAll(".site-header__logo img");
      const icons = document.querySelectorAll(".header-item--icons .site-nav__link");

      if (siteHeader) siteHeader.classList.remove("active");
      if (menuLinks) menuLinks.forEach(item => item.classList.remove("active"));
      if (flag) flag.classList.remove("active");
      if (logos) logos.forEach(item => item.classList.remove("active"));
      if (icons) icons.forEach(item => item.classList.remove("active"));

      this.activeDropdownRef = null;

      const shoppingBar = document.querySelector(".shopping-bar");
      if (shoppingBar) shoppingBar.classList.remove("hide-shopping-bar");
    }

    disableClick(e) {
      const dropdownRef = e.target.textContent.trim();

      const dropdown = this.querySelector(
        `.convx__collection-nav-dropdown[data-nav-reference="${dropdownRef}"]`
      );

      // if dropdown exists → block click
      if (dropdown) {
        e.preventDefault();
      }
    }

    showDropdown(e) {
      const menuLinks = e.target.closest(".convx__menu-link");
      if (!menuLinks) return;

      const ref = menuLinks.textContent.trim();

      const dropdown = this.querySelector(
        `.convx__collection-nav-dropdown[data-nav-reference="${ref}"]`
      );

      // this link has no dropdown of its own (e.g. "Articles") — leave
      // whatever dropdown is currently open alone, since the pointer may
      // just be passing through this item (a different row) on its way
      // to another item's dropdown, not switching to this one
      if (!dropdown) return;

      // back on the link (e.g. from its own dropdown) — cancel any pending
      // close so the dropdown doesn't shut while the pointer is on its link
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      // do nothing if this dropdown is already open
      if (this.activeDropdownRef === ref && dropdown.classList.contains("active")) return;

      this.activeDropdownRef = ref;

      const currentActive = this.querySelector(
        ".convx__collection-nav-dropdown.active"
      );
      if (currentActive) currentActive.classList.remove("active");

      const shoppingBar = document.querySelector(".shopping-bar");
      if (shoppingBar) {
        shoppingBar.classList.add("hide-shopping-bar");
        if (typeof window.stickyHeaderCheck === "function") {
          window.stickyHeaderCheck();
        }
      }

      const siteHeader = document.querySelector(
        ".header-wrapper--sticky .site-header"
      );
      const menuLink = document.querySelectorAll("a.convx__menu-link");
      const flag = document.querySelector(".regions-flag-small-btn");
      const logo = document.querySelectorAll(".site-header__logo img");
      const icons = document.querySelectorAll(
        ".header-item--icons .site-nav__link"
      );
      e.preventDefault();
      dropdown.classList.add("active");
      if (siteHeader) {
        siteHeader.classList.remove("active");
        siteHeader.classList.add("active");
      }
      if (menuLink)
        menuLink.forEach((item) => {
          item.classList.remove("active");
          item.classList.add("active");
        });

      if (flag) {
        flag.classList.remove("active");
        flag.classList.add("active");
      }
      if (logo)
        logo.forEach((item) => {
          item.classList.remove("active");
          item.classList.add("active");
        });
      if (icons)
        icons.forEach((item) => {
          item.classList.remove("active");
          item.classList.add("active");
        });
    }

    showSecondLevel(e) {
      e.preventDefault();
      this.querySelectorAll(
        ".convx__first-level-nav .convx__nav-collection-card"
      ).forEach((item) => {
        item.classList.remove("active");
      });
      const targetElement = e.target.closest(".convx__nav-collection-card");
      if (targetElement) {
        targetElement.classList.add("active");
        const collectionRef = targetElement.dataset.navReference.trim();
        this.querySelectorAll(".convx__second-level-nav").forEach((el) =>
          el.classList.remove("active")
        );
        const target = this.querySelector(
          `.convx__second-level-nav[data-nav-reference="${collectionRef}"]`
        );
        if (target) target.classList.add("active");
      }
    }

    showThirdLevel(e) {
      e.preventDefault();

      const targetElement = e.target.closest(".convx__nav-sidebar-link");
      if (!targetElement) return;

      const seriesRef = targetElement.getAttribute("data-nav-reference");
      if (!seriesRef) return;

      const parentSecondLevel = targetElement.closest(
        ".convx__second-level-nav"
      );
      if (!parentSecondLevel) return;

      parentSecondLevel
        .querySelectorAll(".convx__nav-sidebar-link")
        .forEach((link) => {
          link.classList.remove("active");
        });

      parentSecondLevel
        .querySelectorAll(".convx__third-level-nav")
        .forEach((nav) => {
          nav.classList.remove("active");
        });

      targetElement.classList.add("active");

      const targetThirdLevel = parentSecondLevel.querySelector(
        `.convx__third-level-nav[data-nav-reference="${seriesRef}"]`
      );
      if (targetThirdLevel) {
        targetThirdLevel.classList.add("active");
      }
    }

    /** Sticky header behavior starts here **/

    initStickyHeader() {
      if (!this.header) return;
      this.header.classList.add("cc-header--sticky");
    }

    handleScroll() {
      if (this._scrollTicking) return;
      this._scrollTicking = true;

      requestAnimationFrame(() => {
        this._scrollTicking = false;

        if (!this.header || this.stickyTransitioning) return;
        // page is pinned while the mobile drawer is open (see lockPageScroll)
        if (document.body.classList.contains("drawer-open")) return;

        const scrollTop = document.documentElement.scrollTop;

        // Mobile homepage: the header sticks as soon as the announcement bar has
        // scrolled away, so start tracking direction right from the top.
        const revealBelow =
          window.innerWidth <= 768 &&
          document.body.classList.contains("template-index")
            ? 1
            : 200;

        if (scrollTop < revealBelow) {
          this.showHeader();
        } else if (Date.now() - (window.convxHeaderReflowAt || 0) < 1000) {
          // resizing (or the announcement bar changing height) reflows the
          // page and moves scrollTop — not a real scroll, so leave the menu
          // as it is
        } else if (this.lastScrollPos < scrollTop) {
          this.hideHeader();
        } else if (this.lastScrollPos - 5 > scrollTop) {
          this.showHeader();
        }

        this.lastScrollPos = scrollTop;
      });
    }


    showHeader() {
      if (this.header.classList.contains("is-out")) {
        this.header.classList.remove("is-out");
        this.setHeaderEnd();
      }
    }

    hideHeader() {
      if (!this.header.classList.contains("is-out")) {
        this.header.classList.add("is-out");
        this.setHeaderEnd();
      }
    }

    updateHeaderOffsets() {
      if (!this.header) return;

      let totalHeight = this.header.offsetHeight;
      if (this.announcementBar) {
        totalHeight += this.announcementBar.offsetHeight;
      }

      // Variables on <html> restyle the whole page, so only write when the value
      // actually changes (this runs on every scroll-direction change).
      // (--header-end used to be set here too, but nothing reads it.)
      const contentStart = `${totalHeight.toFixed(1)}px`;
      if (contentStart !== this._contentStart) {
        this._contentStart = contentStart;
        document.documentElement.style.setProperty("--content-start", contentStart);
      }
    }

    setHeaderEnd() {
      requestAnimationFrame(() => this.updateHeaderOffsets());
    }
  }

  class ConvxMobileNav extends HTMLElement {
    constructor() {
      super();
      this.drawer = this.querySelector(".convx__mobile-menu"); // adjust if needed
      this.hamburger = document.querySelector("#convx_nav-hamburger");
    }

    connectedCallback() {
      this.initDrawerToggle();
      this.initNavLinks();
      this.initAccordions();
      this.initBackButtons();
    }

    closeDrawer() {
      if (!this.drawer || !this.drawer.classList.contains("active")) return;

      this.drawer.classList.remove("active");
      this.hamburger.classList.remove("active");
      this.unlockPageScroll();
      document.body.classList.add("drawer-closing");
      setTimeout(() => document.body.classList.remove("drawer-closing"), 300);

      const shoppingBar = document.querySelector(".shopping-bar");
      if (shoppingBar) shoppingBar.classList.remove("hide-shopping-bar");
      const announcementBar = document.querySelector(".announcement-bar");
      if (announcementBar) announcementBar.classList.remove("annoucment-bar-top");
      const menuBar = document.querySelector(".header-sticky-wrapper");
      if (menuBar) menuBar.classList.remove("menu-bar-top");

      const siteHeader = document.querySelector(".header-wrapper--sticky .site-header");
      if (siteHeader) {
        requestAnimationFrame(() => {
          const scrollTop = document.documentElement.scrollTop;
          if (scrollTop > 200) {
            siteHeader.classList.add("active");
          } else {
            siteHeader.classList.remove("active");
          }
        });
      }

      const logo = document.querySelectorAll(".site-header__logo img");
      if (logo) logo.forEach((item) => item.classList.remove("active"));
      const icons = document.querySelectorAll(".header-item--icons a.site-nav__link");
      if (icons) icons.forEach((item) => item.classList.remove("active"));

      this.querySelectorAll(".convx__mobile-sub-menu.active").forEach(
        (menu) => menu.classList.remove("active")
      );
      this.querySelectorAll(".convx__mobile-nav-link.active").forEach(
        (link) => link.classList.remove("active")
      );
      this.querySelectorAll(".convx__dropdown-panel.active").forEach(
        (panel) => panel.classList.remove("active")
      );
      this.querySelectorAll(".convx__dropdown-accordion.active").forEach(
        (accordion) => accordion.classList.remove("active")
      );
    }

    // body.drawer-open pins the page with position: fixed; offset it by the
    // scroll position so the page doesn't jump to the top, and restore that
    // position once the body is unpinned (scrollTo does nothing while fixed).
    lockPageScroll() {
      // --content-start counts the announcement bar, which has scrolled away
      // once the header is stuck; start the drawer where the header really ends.
      const siteHeader = document.querySelector("#SiteHeader");
      if (siteHeader) {
        const headerBottom = Math.max(siteHeader.getBoundingClientRect().bottom, 0);
        this.style.setProperty("--content-start", `${headerBottom}px`);
      }
      this._scrollY = window.scrollY;
      document.body.style.top = `-${this._scrollY}px`;
      document.body.classList.add("drawer-open");
    }

    unlockPageScroll() {
      if (!document.body.classList.contains("drawer-open")) return;
      const scrollY = this._scrollY || 0;
      document.body.classList.remove("drawer-open");
      document.body.style.top = "";
      window.scrollTo(0, scrollY);
    }

    initDrawerToggle() {
      if (!this.hamburger || !this.drawer) return;

      document.addEventListener("predictive-search:open", () => {
        this.closeDrawer();
      });

      this.hamburger.addEventListener("click", () => {
        const siteHeader = document.querySelector(
          ".header-wrapper--sticky .site-header"
        );
        const logo = document.querySelectorAll(".site-header__logo img");
        const icons = document.querySelectorAll(
          ".header-item--icons a.site-nav__link"
        );
        const shoppingBar = document.querySelector(".shopping-bar");
        if (shoppingBar) shoppingBar.classList.add("hide-shopping-bar");
        const announcementBar = document.querySelector(".announcement-bar");
        if (announcementBar) announcementBar.classList.add("annoucment-bar-top");
        const menuBar = document.querySelector(".header-sticky-wrapper");
        if (menuBar) menuBar.classList.add("menu-bar-top");
        if (typeof window.stickyHeaderCheck === "function") {
          window.stickyHeaderCheck();
        }
        const isOpen = this.drawer.classList.toggle("active");

        if (siteHeader) {
          if (isOpen) {
            siteHeader.classList.add("active");
          } else {
            requestAnimationFrame(() => {
              const scrollTop = document.documentElement.scrollTop;

              if (scrollTop > 200) {
                siteHeader.classList.add("active");
              } else {
                siteHeader.classList.remove("active");
              }
            });
          }
        } if (logo)
          logo.forEach((item) => {
            item.classList.toggle("active");
          });
        if (icons)
          icons.forEach((item) => {
            item.classList.toggle("active");
          });

        this.hamburger.classList.toggle("active");

        if (isOpen) {
          this.lockPageScroll();
        } else {
          this.unlockPageScroll();
        }

        if (!isOpen) {
          document.body.classList.add("drawer-closing");

          setTimeout(() => {
            document.body.classList.remove("drawer-closing");
          }, 300); // match your drawer animation duration
          const shoppingBar = document.querySelector(".shopping-bar");
          if (shoppingBar) shoppingBar.classList.remove("hide-shopping-bar");
          const announcementBar = document.querySelector(".announcement-bar");
          if (announcementBar) announcementBar.classList.remove("annoucment-bar-top");
          const menuBar = document.querySelector(".header-sticky-wrapper");
          if (menuBar) menuBar.classList.remove("menu-bar-top");
          // Close all submenus
          this.querySelectorAll(".convx__mobile-sub-menu.active").forEach(
            (menu) => menu.classList.remove("active")
          );

          // Remove active state from nav links
          this.querySelectorAll(".convx__mobile-nav-link.active").forEach(
            (link) => link.classList.remove("active")
          );

          // Close all accordion panels
          this.querySelectorAll(".convx__dropdown-panel.active").forEach(
            (panel) => panel.classList.remove("active")
          );

          // Remove active from accordions
          this.querySelectorAll(".convx__dropdown-accordion.active").forEach(
            (accordion) => accordion.classList.remove("active")
          );
        }
      });
    }

    initNavLinks() {
      const navLinks = this.querySelectorAll(".convx__mobile-nav-link");

      navLinks.forEach((link) => {
        const reference = link.getAttribute("data-mobile-nav-reference");

        link.addEventListener("click", (e) => {
          const subMenu = this.querySelector(
            `.convx__mobile-sub-menu[data-mobile-nav-reference="${reference}"]`
          );

          if (subMenu) {
            e.preventDefault();
            e.stopPropagation();

            subMenu.classList.toggle("active");
            link.classList.toggle("active");
          }
        });
      });
    }

    initAccordions() {
      const accordions = this.querySelectorAll(".convx__dropdown-accordion");

      accordions.forEach((accordion) => {
        accordion.addEventListener("click", () => {
          const panel = accordion.nextElementSibling;

          // Close others
          // this.querySelectorAll(".convx__dropdown-panel").forEach((p) => {
          //   if (p !== panel) p.classList.remove("active");
          // });

          // this.querySelectorAll(".convx__dropdown-accordion").forEach((a) => {
          //   if (a !== accordion) a.classList.remove("active");
          // });

          // Toggle current
          panel.classList.toggle("active");
          accordion.classList.toggle("active");
        });
      });
    }

    initBackButtons() {
      const backButtons = this.querySelectorAll(".convx__back-button");

      backButtons.forEach((button) => {
        button.addEventListener("click", () => {
          const submenu = button.closest(".convx__mobile-sub-menu");
          if (submenu) submenu.classList.remove("active");

          // Also deactivate the corresponding nav link
          const reference = submenu.getAttribute("data-mobile-nav-reference");
          const matchingNavLink = this.querySelector(
            `.convx__mobile-nav-link[data-mobile-nav-reference="${reference}"]`
          );
          if (matchingNavLink) matchingNavLink.classList.remove("active");
        });
      });
    }
  }

  function onDOMContentLoaded() {
    const path = location.pathname;
    const isHomePage = path == "/";
    const isProducts = path.includes("/products");
    const isCollections = path.includes("/collections") && !isProducts;
    const isCart = path == "/cart";

    if (!customElements.get("convx-desktop-nav")) {
      customElements.define("convx-desktop-nav", ConvxDesktopNav);
    }

    if (!customElements.get("convx-mobile-nav")) {
      customElements.define("convx-mobile-nav", ConvxMobileNav);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded, {
      once: true,
    });
  } else {
    onDOMContentLoaded();
  }
})();
